import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, defineComponent, nextTick, onBeforeUnmount, ref, watch } from 'vue';
import { KeyboardKey } from '@/shared/constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    positionX: {
      type: Number,
      default: 0
    },
    positionY: {
      type: Number,
      default: 0
    },
    attach: {
      type: [String, Object],
      default: ''
    },
    contentClass: {
      type: String,
      default: ''
    }
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    defineComponent({
      name: 'ContextPopover'
    });
    var coords = ref({
      top: 0,
      left: 0
    });
    var contentStyle = computed(function () {
      return {
        top: "".concat(coords.value.top, "px"),
        left: "".concat(coords.value.left, "px")
      };
    });
    function attachEl() {
      if (!props.attach || typeof document === 'undefined') {
        return null;
      }
      return typeof props.attach === 'string' ? document.querySelector(props.attach) : props.attach;
    }
    function updatePosition() {
      var el = attachEl();
      if (el) {
        var rect = el.getBoundingClientRect();
        coords.value = {
          top: rect.bottom,
          left: rect.left
        };
        return;
      }
      coords.value = {
        top: props.positionY,
        left: props.positionX
      };
    }
    function getInclude() {
      var el = attachEl();
      return el ? [el] : [];
    }
    function close() {
      emit('input', false);
    }
    function onClickOutside() {
      close();
    }
    function onKeydown(event) {
      if (event.key === KeyboardKey.Escape) {
        close();
      }
    }
    watch(function () {
      return props.value;
    }, function (val) {
      if (typeof document === 'undefined') {
        return;
      }
      if (val) {
        nextTick(updatePosition);
        document.addEventListener('keydown', onKeydown);
      } else {
        document.removeEventListener('keydown', onKeydown);
      }
    }, {
      immediate: true
    });
    onBeforeUnmount(function () {
      if (typeof document !== 'undefined') {
        document.removeEventListener('keydown', onKeydown);
      }
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      coords: coords,
      contentStyle: contentStyle,
      attachEl: attachEl,
      updatePosition: updatePosition,
      getInclude: getInclude,
      close: close,
      onClickOutside: onClickOutside,
      onKeydown: onKeydown
    };
  }
});